var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMicrophone = function SvgMicrophone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0013 16.792C15.3955 16.792 17.3346 14.8528 17.3346 12.4587V6.50033C17.3346 4.10616 15.3955 2.16699 13.0013 2.16699C10.6071 2.16699 8.66797 4.10616 8.66797 6.50033V12.4587C8.66797 14.8528 10.6071 16.792 13.0013 16.792Z",
    stroke: "#4239FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71094 10.4541V12.2958C4.71094 16.8674 8.42677 20.5833 12.9984 20.5833C17.5701 20.5833 21.2859 16.8674 21.2859 12.2958V10.4541",
    stroke: "#4239FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4961 6.96539C12.4711 6.60789 13.5328 6.60789 14.5078 6.96539",
    stroke: "#4239FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1328 10.2622C12.707 10.1105 13.3028 10.1105 13.877 10.2622",
    stroke: "#4239FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.583V23.833",
    stroke: "#4239FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMicrophone);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjAwMTMgMTYuNzkyQzE1LjM5NTUgMTYuNzkyIDE3LjMzNDYgMTQuODUyOCAxNy4zMzQ2IDEyLjQ1ODdWNi41MDAzM0MxNy4zMzQ2IDQuMTA2MTYgMTUuMzk1NSAyLjE2Njk5IDEzLjAwMTMgMi4xNjY5OUMxMC42MDcxIDIuMTY2OTkgOC42Njc5NyA0LjEwNjE2IDguNjY3OTcgNi41MDAzM1YxMi40NTg3QzguNjY3OTcgMTQuODUyOCAxMC42MDcxIDE2Ljc5MiAxMy4wMDEzIDE2Ljc5MloiIHN0cm9rZT0iIzQyMzlGQiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuNzEwOTQgMTAuNDU0MVYxMi4yOTU4QzQuNzEwOTQgMTYuODY3NCA4LjQyNjc3IDIwLjU4MzMgMTIuOTk4NCAyMC41ODMzQzE3LjU3MDEgMjAuNTgzMyAyMS4yODU5IDE2Ljg2NzQgMjEuMjg1OSAxMi4yOTU4VjEwLjQ1NDEiIHN0cm9rZT0iIzQyMzlGQiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTExLjQ5NjEgNi45NjUzOUMxMi40NzExIDYuNjA3ODkgMTMuNTMyOCA2LjYwNzg5IDE0LjUwNzggNi45NjUzOSIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuMTMyOCAxMC4yNjIyQzEyLjcwNyAxMC4xMTA1IDEzLjMwMjggMTAuMTEwNSAxMy44NzcgMTAuMjYyMiIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMgMjAuNTgzVjIzLjgzMyIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";